<template>
    <div class="home" :style="{ minHeight: bodyHeight + 'px' }">
        <gHead2 />
        <div class="gContent" :style="{ minHeight: bodyHeight - 400 + 'px' }">
            <div class="login-box">
                <div class="register">
                    <div class="re-title">Invitation Letter</div>
                    <Form ref="formInline" :model="formInline" :rules="ruleInline" label-position="right" :label-width="400"
                        @submit.native.prevent style="width: 1000px; margin: 0 auto">

                        <FormItem label="Surname / Given Name as shown on passport：" prop="passport">
                            <Input type="text" style="width: 300px" v-model="formInline.passport"
                                placeholder="Please enter"  maxlength="50"/>
                        </FormItem>

                        <FormItem label="Company Name：" prop="name">
                            <Input type="text" style="width: 300px" v-model="formInline.name" placeholder="Please enter"  maxlength="200" />
                        </FormItem>
                        <FormItem label="Nationality：" prop="nationality">
                            <Input type="text" style="width: 300px" v-model="formInline.nationality"
                                placeholder="Please enter"  maxlength="50"/>
                        </FormItem>
                        <FormItem label="Telephone：" prop="phone">
                            <Input type="text" style="width:300px;" v-model="formInline.phone" placeholder="Please enter"  maxlength="20"/>
                            <p>+86-XXX-XXXXXXX</p>
                        </FormItem>
                        <FormItem label="E-mail Address：" prop="email">
                            <Input type="text" style="width:300px;" v-model="formInline.email" placeholder="Please enter"  maxlength="50" />
                        </FormItem>


                        <!-- <FormItem prop="country" id="country">
              
                        <Select style="width: 230px" v-if="countryList" v-model="formInline.country"
                        placeholder='Please select your country'>
                        <Option v-for="(item, index) in countryList" :value="item.value" :label="$t(item.value)" :key="index">
                            {{ item.value }}</Option>
                        </Select>
                    </FormItem> -->


                        <Button type="primary" @click="handleSubmit('formInline')" size="large" :loading="loading"
                            class="re-btn">Submit Information</Button>
                    </Form>

                </div>
            </div>
        </div>
        <gBottom />
        <iModal style="width: 600px;" v-model="dialog" title="Tip" class-name="vertical-center-modal" :footer-hide="true">
            <div style="margin-bottom:20px;text-align:center">
                <p style="font-weight: bold;margin-bottom:15px">
                    Application submitted successfully.
                </p>
                <p style="font-weight: bold;">
                    Theservice personnel will contact you shortly
                </p>
            </div>

            <div style="    text-align: center;">

                <Button type="primary" @click="dialog = false" size="large" class="re-btn">Sure</Button>
            </div>
        </iModal>
    </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from "vuex";
import gHead2 from "@components/En/gHead2/gHead2.vue";
import gBottom from "@components/En/gBottom/gBottom.vue";
import config from "@assets/config.json";
import { country } from "@/other/country";
export default {
    name: "audience-login",
    data () {
        let validatePhone = (rule, value, callback) => {
            
                callback();
            
        }

        return {
            model1: false,
            bodyHeight: "800px",
            loading: false,
            agree: false,
            dialog: false,
            showModel: false,
            timer: false,
            count: 0,
            dateTypeChange: "",
            formInline: {
                passport: "",
                name: "",
                nationality: "",
                phone: "",
                email: "",
            },
            ruleInline: {
                // phone: validator.Address,
                passport: [
                    {
                        required: true,
                        message: "Please enter the Surname / Given Name as shown on passport",
                        trigger: "blur",
                    },
                ],
                name: [
                    {
                        required: true,
                        message: "Please enter the Company Name",
                        trigger: "blur",
                    },
                ],
                nationality: [
                    {
                        required: true,
                        message: "Please enter the Nationality",
                        trigger: "blur",
                    }
                ],
                phone: [
                    {
                        required: true,
                        validator: validatePhone,
                        trigger: "blur",
                    },
                    // { pattern: 11 , message: "Incorrect phone number format", trigger: "blur" },
                ],
                email: [
                    {
                        required: true,
                        message: "Email address cannot be empty",
                        trigger: "blur",
                    },
                    { type: "email", message: "Incorrect email format", trigger: "blur" },
                ],
            },
            countryList: [], //国家数组

        };
    },
    components: {
        gHead2,
        gBottom,
    },
    computed: {
        ...mapGetters({
            ExhibitionIdArr: 'getExhibitionIdArr',
        }),
    },
    methods: {
        ...mapActions({
            getImgCode: "loginModule/getImgCode",
            validateImgCode: "loginModule/validateImgCode",
            getMsgCodeEmail: "loginModule/getMsgCodeEmail",
            validateEmailCode: "loginModule/validateEmailCode",
            audienceRegister: "loginModule/audienceRegister",
            postAddMember: "loginModule/postAddMember",
            checkUserName: "loginModule/checkUserName",
            postInformationGatheringAdd: "loginModule/postInformationGatheringAdd",
            getCountry: 'getCountry',
        }),
        async validUserName (value) {
            let res = await this.checkUserName(value);
        },
        async Country () {
            let arr = await this.getCountry();
            for (let i = 0; i < arr.length; i++) {
                let obj = {};
                obj.value = arr[i].nameEn;
                obj.lable = arr[i].nameEn;
                this.countryList.push(obj);
            }
            console.log(arr, "123");
        },
        async handleSubmit (name) {
            let form = this.formInline;
            // 验证表单
            let valid = await this.validForm(name);
            if (!valid) return;


            let req = {
                dateType: this.dateTypeChange == 1 ? 'VISIT' : "EXHIBIT",
                sureName: form.passport,
                companyName: form.name,
                nationality: form.nationality,
                tel: form.phone,
                email: form.email,
                pageType: "EN"
            };
            this.loading = true;
            setTimeout(() => {
                this.loading = false;
            }, 5000);
            let bool = await this.postInformationGatheringAdd(req);
            if (bool.successed) {
                this.$Message.success("Successfully submitted!");
                this.dialog = true
                // this.$router.push("/loginEn/succeedEn2");
            } else {
                this.loading = false;
                if (bool.errors && bool.errors[0]) {
                    this.$Message.error(bool.errors[0].description);
                    return;
                } else {
                    this.$Message.error("Submission failed, please try again");
                }
            }
            this.loading = false;
        },





        validForm (name) {
            // 验证表单
            return new Promise((resolve, reject) => {
                this.$refs[name].validate((valid) => {
                    resolve(valid);
                });
            });
        },




        async downTime () {
            const valid = await this.getMsgCodeEmail(this.formInline.Address);
            const TIME_COUNT = 60;

            if (!this.timer) {
                console.log(this.timer, "cascasc");
                this.count = TIME_COUNT;
                this.showCode = false;
                this.timer = setInterval(() => {
                    if (this.count > 0 && this.count <= TIME_COUNT) {
                        this.count--;
                    } else {
                        this.showCode = true;
                        clearInterval(this.timer);
                        this.timer = null;
                    }
                }, 1000);
            }
        },
        loadData (item, callback) {
            item.loading = true;
            setTimeout(() => {
                console.log(item);
                item.loading = false;
                callback();
            }, 1000);
        },
    },
    created () {

        this.dateTypeChange = this.$route.query.id
        this.provinceArr = country.data;
        this.Country()
        // this.getCode();

    },
};
</script>

<style scoped lang="scss">
.register {
    width: 1200px;
    margin: 30px auto 60px;

    .re-title {
        font-size: 20px;
        text-align: center;
        color: #333;
        margin-bottom: 40px;
        // padding-left: 140px;
    }

    /deep/ .ivu-input {
        height: 42px;
    }

    /deep/ .ivu-form-item-label {
        color: #222;
        height: 42px;
        padding-top: 0;
        padding-bottom: 0;
        line-height: 42px;
    }

    /deep/ .ivu-select-selection {
        height: 42px;
    }

    /deep/ .ivu-select-placeholder {
        line-height: 42px;
    }

    /deep/ .ivu-select-selected-value {
        line-height: 42px;
    }

    .re-btn {
        width: 300px;
        height: 42px;
        margin-top: 40px;
        margin-left: 380px;
        font-size: 18px;
    }

    .re-tip-info {
        margin-left: -10px;
        color: #1890ff;
        cursor: pointer;
    }

    .terms {
        /deep/ .ivu-form-item-content {
            width: 435px;
            margin-left: 0 !important;
            text-align: center;
        }
    }

    .img-code {
        width: 70px;
        height: 30px;
        position: absolute;
        top: 6px;
        left: 224px;
        cursor: pointer;
    }

    .txt-code {
        display: inline-block;
        width: 200px;
        position: absolute;
        top: 5px;
        left: 142px;
        cursor: pointer;
        color: #1890ff;
    }

    .disabled {
        color: #ccc;
        left: 100px;
    }
}
</style>
